import { Component, OnInit } from '@angular/core';
import { SiteActions, SiteSelectors } from '@next/core-lib/site';
import { Store } from '@ngrx/store';

import { SiteState } from '../shared/models/siteState.model';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['information.component.scss'],
  standalone: false,
})
export class InformationComponent implements OnInit {
  pageTitle$ = this.store.select(SiteSelectors.selectPageTitle);

  constructor(private readonly store: Store<SiteState>) {}

  ngOnInit() {
    this.store.dispatch(SiteActions.updatePageTitle({ pageTitle: 'information' }));
  }
}
